import { CaretDown, CaretUp } from "@phosphor-icons/react";
import Button from "./Button";
import DropdownMenu from "./DropdownMenu";
import FormCheckbox from "./FormCheckbox";

export type MultiSelectDropdownItemOption<T> = {
    label: string;
    value: T;
};

type MultiSelectDropdownProps<T> = {
    label: string;
    selected: T[];
    options: MultiSelectDropdownItemOption<T>[];
    onSelect: (value: T) => void;
    onClear: () => void;
};

const MultiSelectDropdown = <T,>({
    label,
    selected,
    options,
    onSelect,
    onClear,
}: MultiSelectDropdownProps<T>) => {
    return (
        <DropdownMenu.Container>
            <DropdownMenu.Trigger>
                {({ open }) => (
                    <div className="flex items-center">
                        {label}
                        {selected.length > 0 && (
                            <span className="ml-1">
                                (<b>{selected.length}</b>)
                            </span>
                        )}
                        <span className="ml-2">
                            {open ? (
                                <CaretUp weight="bold" />
                            ) : (
                                <CaretDown weight="bold" />
                            )}
                        </span>
                    </div>
                )}
            </DropdownMenu.Trigger>
            <DropdownMenu.Items>
                <div className="max-h-[15.5rem] overflow-y-auto py-1 w-[300px]">
                    {options.map((option) => (
                        <div className="px-3 py-1" key={`${option.value}`}>
                            <FormCheckbox
                                id={`checkbox-${option.value}`}
                                checked={selected.includes(option.value)}
                                label={option.label}
                                onChange={() => onSelect(option.value)}
                            />
                        </div>
                    ))}
                </div>
                <div className="p-3 border-t">
                    <Button
                        variant="outline"
                        className="w-full"
                        onClick={onClear}
                    >
                        Clear filter
                    </Button>
                </div>
            </DropdownMenu.Items>
        </DropdownMenu.Container>
    );
};

export default MultiSelectDropdown;
